import _defineProperty from "/buddy/remotehvac-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
// Style as inline component
import { unit } from '@ant-design/cssinjs';
import { genCompactItemStyle } from '../../style/compact-item';
import { genCompactItemVerticalStyle } from '../../style/compact-item-vertical';
import { genSubStyleComponent } from '../../theme/internal';
import { prepareComponentToken, prepareToken } from './token';
var genButtonCompactStyle = function genButtonCompactStyle(token) {
  var componentCls = token.componentCls,
    calc = token.calc;
  return _defineProperty({}, componentCls, _defineProperty(_defineProperty({}, "&-compact-item".concat(componentCls, "-primary"), _defineProperty({}, "&:not([disabled]) + ".concat(componentCls, "-compact-item").concat(componentCls, "-primary:not([disabled])"), {
    position: 'relative',
    '&:before': {
      position: 'absolute',
      top: calc(token.lineWidth).mul(-1).equal(),
      insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
      display: 'inline-block',
      width: token.lineWidth,
      height: "calc(100% + ".concat(unit(token.lineWidth), " * 2)"),
      backgroundColor: token.colorPrimaryHover,
      content: '""'
    }
  })), '&-compact-vertical-item', _defineProperty({}, "&".concat(componentCls, "-primary"), _defineProperty({}, "&:not([disabled]) + ".concat(componentCls, "-compact-vertical-item").concat(componentCls, "-primary:not([disabled])"), {
    position: 'relative',
    '&:before': {
      position: 'absolute',
      top: calc(token.lineWidth).mul(-1).equal(),
      insetInlineStart: calc(token.lineWidth).mul(-1).equal(),
      display: 'inline-block',
      width: "calc(100% + ".concat(unit(token.lineWidth), " * 2)"),
      height: token.lineWidth,
      backgroundColor: token.colorPrimaryHover,
      content: '""'
    }
  }))));
};
// ============================== Export ==============================
export default genSubStyleComponent(['Button', 'compact'], function (token) {
  var buttonToken = prepareToken(token);
  return [
  // Space Compact
  genCompactItemStyle(buttonToken), genCompactItemVerticalStyle(buttonToken), genButtonCompactStyle(buttonToken)];
}, prepareComponentToken);